import React from 'react';
import Home from '../pages/Home';
import About from '../pages/About';
import Services from '../pages/Services';
import CaseStudies from '../pages/CaseStudies';
import Testimonials from '../pages/Testimonials';
import Blog from '../pages/Blog';
import BlogPostPage from '../pages/blog/[slug]';
import Contact from '../pages/Contact';
import Admin from '../pages/Admin';
import QuestionnairePage from '../pages/QuestionnairePage';

// Family Protection Center
import FamilyProtectionCenter from '../pages/family-insurance/index';

// Business Owner Command Center
import BusinessOwnerCommandCenter from '../pages/business-insurance/index';

// Private Advisory Process
import PrivateAdvisoryProcess from '../pages/private-advisory/Process';

interface RouteConfig {
  path: string;
  element: React.ReactNode;
}

export const publicRoutes: RouteConfig[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/case-studies",
    element: <CaseStudies />,
  },
  {
    path: "/testimonials",
    element: <Testimonials />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/:slug",
    element: <BlogPostPage />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "/family-insurance",
    element: <FamilyProtectionCenter />,
  },
  {
    path: "/business-insurance",
    element: <BusinessOwnerCommandCenter />,
  },
  {
    path: "/private-advisory/process",
    element: <PrivateAdvisoryProcess />,
  },
  {
    path: "/q/:token",
    element: <QuestionnairePage />,
  },
];
